import {useCallback, useContext, useEffect, useRef, useState} from "react";
import {PublicRoot} from "../App";
import {ClientBridge} from "../index";
import PropTypes from "prop-types";
import {defaultCategories} from "./defaultBridgeData";
import {extractKeywords} from "./utils";
import {find, pick, get, isUndefined} from "lodash";

export function useSearch(name, options={}) {

    //todo
    const {
        pageSize:defaultPageSize = 20,
        //order:defaultOrder = '??'
    } = options;

    const publicRoot = useContext(PublicRoot);
    const testData = Array.from(new Array(9)).map((_val, i) => ({
        getThumbUrl: ()=>`${publicRoot}/images/thumb.jpg`,
        getPreviewUrl: ()=>`${publicRoot}/images/preview.jpg`,
        name: `Ad_name${i}`,
    }));

    const clientBridge = useContext(ClientBridge);
    const [state, setState] = useState({status: clientBridge.connected ? 'init' : 'offline'});
    const search =  useRef(clientBridge.connected && new clientBridge.mcc.Search(name));

    // todo ?this still does not seem to ensure a "static" function
    const sendQuery = useCallback(async (formData,{page=1, pageSize=defaultPageSize}) => {

        console.log('Search triggered');
        setState({status:'loading'});

        if (!clientBridge.connected) {
            setTimeout(
                ()=> setState({
                    status:'success',
                    results: {
                        records:testData.slice(0,pageSize),
                        total: 30
                    },
                    query:formData}
            ), 5000);
            return;
        }

        try {
            const mccQuery = clientBridge.wizard.getQueryFromFormData(formData);
            search.current.setQuery(mccQuery);

            const start = (page-1)*pageSize +1;
            let results = await search.current.execute(start, pageSize, clientBridge.wizard.order);
            if (results.total===0 ) {
                search.current.query.search.keywords="";
                search.current.total = null ;  ///force research - should be function....
                results = await search.current.execute(start, pageSize, clientBridge.wizard.order);
            }

            setState({status:'success', results, query:formData});
        } catch (error){
            setState({status:'failed', error});
        }
    },[clientBridge,defaultPageSize,testData]);

    return [state, sendQuery];
}
useSearch.propTypes = {
    name : PropTypes.string.isRequires
};

// grab and set data from the desktop UI
export function useFormData(name, options={}) {

    const testData = {
        company: {
            address: "1 Alpha Str",
            city: "Allberg",
            name: "Ace Plumbers",
            phone: "123-456-7890",
            state: "AC",
            web: "www.aceplumbers.com",
            zip: "12345"
        },
        exactMatch: false,
        holidayOnly: false,
        keyword: "plumbing",
        medium: ["print"],
        bizType: "Home Service Businesses > Plumber or Plumbing Contractor"
    };

    const {bizLookup, pickerDataTree} = useBizTypes();
    const clientBridge = useContext(ClientBridge);
    let data = clientBridge.connected
        ? clientBridge.wizard.getFormData()
        : testData ;
    if (data && data.company ) {

        const bizType = data.bizType || '';

        if (bizType.includes('>')) {
            data.company.category = bizType.replace(/\s*>.*$/, '');
            data.company.type = bizType.replace(/^.*>\s*/, '');
        } else {
            const keywords = extractKeywords(bizType);
            const found = find(bizLookup,{type:bizType}) || find(bizLookup,{keywords});
            if (found) {
                data.company.category = found.category;
                data.company.type = found.type;
            } else {
                data.company.category = '';
                data.company.type = bizType;
            }
        }
    } else {
        data = {
            company: {
                category: '',
                type: ''
            }
        }
    }

    // should pick up Relevance project
    if (! find(pickerDataTree, pick(data.company,'category'))) {
        data.company.category = pickerDataTree.length === 1 ? pickerDataTree[0].category : '';
    }

    const [formData, setFormData] = useState(data);

    useEffect(()=>{
        if (clientBridge.connected ) {
            // todo ? move bizType inside company in desk top
            if ( ! isUndefined(get(formData, 'company.category'))) {
                //formData.bizType = formData.company.bizType;
                formData.bizType = formData.company.category
                    + (formData.company.category && formData.company.type ? ' >' : '')
                    + formData.company.type;
                clientBridge.wizard.saveFormData(formData);
            }
        }
    },[formData, formData.company,  clientBridge]);

    if (clientBridge.connected) {
        if (!clientBridge.wizard.mobileDataMaster) {
            console.log('hook grabbing');
            setFormData(data);
            clientBridge.wizard.mobileDataMaster = true;
        }
    }

    return [formData, setFormData];
}

export function usePresenatation(){
    const clientBridge = useContext(ClientBridge);
    const [presentation, setPresentation] = useState({});

    useEffect(()=>{
        if (clientBridge.connected && clientBridge.wizard.adSeller) {
            setPresentation(clientBridge.wizard.adSeller.presentation);
        }
    },[clientBridge]);

    return presentation;
}



const processCategories = (categories={}) => {

    const pickerDataTree= [];
    const bizLookup = {};   // Note some types in more that one category e.g Bank.
                            // but we can only find one & the keywords will be the same anyway

    Object.keys(categories).sort().forEach((categoryName)=>
    {
        const item = {
            label: categoryName,
            category: categoryName,
            value: categoryName,
            keywords: extractKeywords(categoryName),
            types: []
        };
        pickerDataTree.push(item);
        bizLookup[categoryName]= item;

        Object.keys(categories[categoryName].types).sort().forEach((typeName)=>
        {
            const subItem = {
                label: typeName,
                category: categoryName,
                value: typeName,
                type: typeName,
                keywords: categories[categoryName].types[typeName]
            };
            item.types.push(subItem);
            bizLookup[typeName]= subItem;
        });
    });

     return {bizLookup, pickerDataTree};
};

export function useBizTypes(){
    //const { data, error, isPending } = useAsync();

    const clientBridge = useContext(ClientBridge);
    const [bizTypes, setBizTypes] = useState(processCategories());

    useEffect(()=> {
            if (clientBridge.connected) {
                clientBridge.wizard.bizTypesLoading.then(
                    categories => setBizTypes(processCategories(categories))
                )
            } else {
                setBizTypes(processCategories(defaultCategories));
            }
        }
        ,[clientBridge]);

   return bizTypes;
}






const defaultProfile = {
    ACCESSLEVEL: "Enhanced",
    ACCOUNTNUMBER: "48595",
    ACCOUNTSTATUS: "active",
    CN: "Franken Stien",
    COUNTRY: "USA",
    DENYFEATURE: [""],
    EMAIL: "dave@metro-email.com",
    FACSIMILETELEPHONENUMBER: "212 967 4602",
    GETTYPW: "",
    GETTYUID: "",
    GIVENNAME: "Franken",
    GROUPNAME: "48595",
    MAXDOWNLOADS: "",
    MESSAGELEVEL: "All",
    MIADPRICE: "",
    PARENTNAME: "48595",
    POSITION: ["CAP", "IKY"],
    PROJECTSHARE: "",
    PULSEID: "",
    SALUTATION: "",
    SERVICENAME: ["Templated Sections", "High Res Images", "Auto USA", "Metro Newspaper Service", "MiAD", "Campaigns & Classified", "Classified Dynamics", "MiAD Spec Ad Library", "Sales Spectaculars", "Auto Images", "Logo Images", "Food Images", "Plus Business", "Templated Sections", "Bonus", "Editorial", "Plus Business"],
    SN: "Stien",
    TAG: ["Ad Seller"],
    TELEPHONENUMBER: "333 333     ",
    TITLE: "Composition",
    UID: "FS311460",
    USEFEATURE: [],
    USERTYPE: "regular",
    WEEKLYFEATURE: "",
    serviceLower: ["templated sections", "high res images", "auto usa", "metro newspaper service", "miad", "campaigns & classified", "classified dynamics", "miad spec ad library", "sales spectaculars", "auto images", "logo images", "food images", "plus business", "templated sections", "bonus", "editorial", "plus business"]
};

const defaultLogin = {
    profile:defaultProfile,
    user:defaultProfile.UID,
    adServices: ["Metro Newspaper Service", "Classified Dynamics", "Sales Spectaculars", 'Holiday Adv. Service'],
    login:()=>{}
};

export function useLogin(){
    const clientBridge = useContext(ClientBridge);
    const [login, setLogin] = useState({user:'guest', login:()=>{}, adServices:[], profile:{}});

    useEffect(()=> {
            if (clientBridge.connected) {
                setLogin(pick(clientBridge.mccLogin,['profile', 'user', 'adServices', 'login']));
            } else {
                setLogin({
                    user:'guest',
                    login:()=>setLogin(defaultLogin),
                    profile: {}, //guest profile...
                    adServices: ["Metro Newspaper Service", "Classified Dynamics", "Sales Spectaculars"]
                });
            }
        }
        ,[clientBridge]);

    return login;
}